import React from 'react'
import NotificationCenterChatItemView from '../variants/NotificationCenterChatItemView'
import { NOTIFICATION_TYPES } from '../../../../../constants'

const formatString = (string, limit) =>
  string && string.length > limit
    ? `${string.slice(0, limit - 3).trim()}...`
    : string

const NotificationCenterItem = ({ type, title, description, action }) => {
  if (type === NOTIFICATION_TYPES.CHAT) {
    return (
      <NotificationCenterChatItemView
        title={formatString(title, 23)}
        description={formatString(description, 23)}
        action={action}
      />
    )
  }
  return null
}

export default NotificationCenterItem
